import { invoke } from '@shared/easyfy.decorators';

// Define types for ParcelLab
interface ParcelLabOptions {
  lang: string;
  plUserId: string;
  use_origin_courier: boolean;
  forceZip: boolean;
  trackingNo?: string;
  show_searchForm: boolean;
  show_zipCodeInput: boolean;
  show_articleList: boolean;
  use_campaign_banners: boolean;
}

interface parcelLabTrackAndTrace {
  // eslint-disable-next-line @typescript-eslint/no-misused-new
  new (): parcelLabTrackAndTrace;
  initialize(options: ParcelLabOptions): void;
}

// Extend the Window interface to include ParcelLab
declare global {
  interface Window {
    parcelLabTrackAndTrace?: parcelLabTrackAndTrace;
  }
}

@invoke
// eslint-disable-next-line @typescript-eslint/no-unused-vars
class MyPagesTrackingAndTraceParcel {
  private readonly selector: string = '.pl-trace';

  constructor() {
    this.initializeParcelLab();
  }

  private getLangFromCulture(): string {
    const htmlElement = document.documentElement;
    const culture = htmlElement.lang || 'en-US';
    const lang = culture.split('-')[0]; // This will return 'sv' from 'sv-SE'
    return lang === 'nb' ? 'no' : lang; // changing to 'no' since parcelLab doesn't support 'nb'
  }

  private getLang(): string {
    const element = document.querySelector(this.selector) as HTMLElement;
    return element?.dataset.parcellabLang || 'en-US';
  }

  private getUserId(): string {
    const element = document.querySelector(this.selector) as HTMLElement;
    return element?.dataset.parcellabUserid || '';
  }

  private getStyleCdn(): string {
    const element = document.querySelector(this.selector) as HTMLElement;
    return element?.dataset.parcellabStylecdn || '';
  }

  private getScriptCdn(): string {
    const element = document.querySelector(this.selector) as HTMLElement;
    return element?.dataset.parcellabScriptcdn || '';
  }

  private loadStyles(): void {
    const styles: HTMLLinkElement = document.createElement('link');
    styles.rel = 'stylesheet';
    styles.href = this.getStyleCdn();
    document.getElementsByTagName('head')[0]?.appendChild(styles);
  }

  private loadScript(callback: () => void): void {
    const script: HTMLScriptElement = document.createElement('script');
    script.async = true;
    script.src = this.getScriptCdn();
    (document.getElementsByTagName('head')[0] || document.getElementsByTagName('body')[0])?.appendChild(script);
    script.onload = callback;
  }

  private initializeParcelLab(): void {
    if (window.parcelLabTrackAndTrace) {
      this.setupParcelLab();
      return;
    }

    this.loadStyles();
    this.loadScript(() => this.setupParcelLab());
  }

  private setupParcelLab(): void {
    const options: ParcelLabOptions = {
      lang: this.getLang(),
      plUserId: this.getUserId(),
      use_origin_courier: true,
      forceZip: true,
      show_searchForm: true,
      show_zipCodeInput: true,
      show_articleList: true,
      use_campaign_banners: true,
    };

    window.parcelLabTrackAndTrace?.initialize(options);
  }
}
